<div class="text-center" *ngIf="loadingReceivedMessages">
  <ap-spinner size="3"></ap-spinner>
</div>
<div *ngIf="!loadingReceivedMessages">
  <table id="{{Id}}-received-messages-table" class="table emds-table table-sticky-header table-fixed table-striped messages-received-table">
    <tbody>
      <ng-container>
        <tr *ngFor="let receivedItem of messagesReceivedPage"
              [apColorBorder]="receivedItem.Urgency">
          <td id="{{Id}}-{{receivedItem.MessageId}}-subject" class="message-subject" [ngStyle]="{'font-weight': (!readOnly && receivedItem.UnreadMessageCount && receivedItem.UnreadMessageCount > 0) ? 'bold' : 'normal'}" >
            <a (click)="openReplyModal(receivedItem)" [class.disabled]="readOnly">{{receivedItem.CreatedDate | date:'h:mm a'}} - {{receivedItem.CreatedDate | date:'M/d/yyyy'}}</a>
            <br/>
            {{receivedItem.Header}}
          <span *ngIf="!readOnly && receivedItem.UnreadMessageCount && receivedItem.UnreadMessageCount > 1" class="badge badge-primary"> {{receivedItem.UnreadMessageCount}}</span>
          </td>

          <td id="{{Id}}-{{receivedItem.MessageId}}-name" class="patient-name" [ngStyle]="{'font-weight': (!readOnly && receivedItem.UnreadMessageCount && receivedItem.UnreadMessageCount > 0) ? 'bold' : 'normal'}" translate="{{receivedItem.PatientLastName}}, {{receivedItem.PatientFirstName}}"></td>

          <td id="{{Id}}-{{receivedItem.MessageId}}-status" class="message-status" [ngStyle]="{'font-weight': (!readOnly && receivedItem.UnreadMessageCount && receivedItem.UnreadMessageCount > 0) ? 'bold' : 'normal'}">
            <span *ngIf="!receivedItem.IsCompleted" translate>Incomplete</span>
            <span *ngIf="receivedItem.IsCompleted" translate>Complete</span>
          </td>

          <td id="{{Id}}-{{receivedItem.MessageId}}-danger" class="message-danger">
            <!--<span *ngIf="receivedItem.IsDanger"><i class="material-icons md-14 danger mt-2">lens</i></span>-->
          </td>

          <td id="{{Id}}-{{receivedItem.MessageId}}-actions" class="message-actions">
            <!--<a title="Actions" *ngIf="!readOnly"><i class="material-icons md-24" title="Actions">more_horiz</i></a>-->
          </td>
        </tr>
        <div *ngIf="totalItems ===0" translate>No Messages found</div>
      </ng-container>
    </tbody>
  </table>
  <pagination [totalItems]="totalItems" (pageChanged)="pageChanged($event)" itemsPerPage="10" [(ngModel)]="currentPage"></pagination>
</div>
